module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 015.feb9eefe.jpg";